var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('label',{staticClass:"toggle-switch"},[_c('input',{attrs:{"type":_vm.type,"disabled":_vm.isDisabled},domProps:{"checked":_vm.checked,"value":_vm.value},on:{"change":_vm.onCheckBoxUpdate}}),_c('span',{staticClass:"toggle-switch-slider"})])])
}
var staticRenderFns = []

export { render, staticRenderFns }